<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
			<v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Estrazione indirizzi mail</p>
                    <v-spacer></v-spacer>
                </v-card-title>
				<v-divider></v-divider>
				<v-container class="mt-4 pa-2" fluid>
					<v-row class="ma-0">
						<v-col class="py-0" cols="3">
							<gmh-date-picker
								v-model="model['from']"
								label="Da"
								:clearable="false"
							></gmh-date-picker>
						</v-col>

						<v-col class="py-0" cols="3" >
							<gmh-date-picker
								v-model="model['to']"
								label="A"
								:min="model['from']"
								:clearable="false"
							></gmh-date-picker>
						</v-col>						
						<v-col class="py-0" cols="12" >
							<v-autocomplete
								:items="fieldsset.companycategories.options"
								label="Categorie aziende"
								v-model="model['category_id']"
								clearable
								small-chips
								multiple
								dense
								outlined
							></v-autocomplete>
						</v-col>														
						<v-col class="py-0" cols="12" >
							<v-autocomplete
								:items="fieldsset.products.options"
								label="Prodotti"
								v-model="model['product_id']"
								clearable
								small-chips
								disable-initial-sort
								multiple
								dense
								outlined
							></v-autocomplete>
						</v-col>
					</v-row>
					
					<v-row class="ma-0"  justify="center">
						<v-col lg="2" md="2" sm="6">	
							<v-list two-line class="background-2">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="primary">business</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Aziende trovate</v-list-item-title>
										<v-list-item-subtitle>{{ countMissing + countEmails }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-col>
						<v-col lg="2" md="2" sm="6">	
							<v-list two-line class="background-2">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="success">mail</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Mail trovate</v-list-item-title>
										<v-list-item-subtitle>{{ countEmails }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>	
						</v-col>		
						<v-col lg="2" md="2" sm="6">	
							<v-list two-line class="background-2">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="error">mail</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Mail mancanti</v-list-item-title>
										<v-list-item-subtitle>{{ countMissing }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>	
						</v-col>
					</v-row>
					<v-row class="pt-2 pb-2" v-if="filtered">
						<v-subheader>Mail PEC</v-subheader>
						<v-col class="pl-0" cols="12">
							<p class="px-3"><span v-for="pec in pecs" :key="pec">{{ pec }}; </span></p>
						</v-col>							
						<v-subheader>Mail</v-subheader>
						<v-col class="pl-0" cols="12">
							<p class="px-3"><span v-for="mail in emails" :key="mail">{{ mail }}; </span></p>
						</v-col>
						<v-subheader>Mail non trovata per</v-subheader>
						<v-col class="pl-0" cols="12">
							<p class="px-3"><span v-for="m in missing" :key="m">{{ m }}; </span></p>
						</v-col>
					</v-row>
				</v-container>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>

	export default {
		name: "extrapolation-mails",
		props: {

		},
		data() {
			return {
				fieldsset: {},
				headers: [],
				model: {},
				loaded: false,
				emails: [],     
				countEmails: 0,     
				pecs: [],
				countPecs: 0,
				missing: [],     
				countMissing: 0,
				filtered: false,
			}
		},

		created() {
			this.axios.get('marbecextrapolationmails-info').then(response => {
				// get body data
				this.fieldsset = response.data.info.fields

				_.forEach(this.fieldsset, (value, key) => {
					if(value.default) {
						Vue.set(this.model, value.key, value.default)
					}
				})

				this.$store.commit('endProgress')

			}, response => {
				// error callback
			});
		},

		watch: {
			model: {
				handler() {
					this.getData()
				},
				deep: true,
			}
		},

		methods: {

			getData() {
				this.axios.post('marbecextrapolationmails', this.model).then(response => {
					this.emails = response.data.data.emails
					this.countEmails = response.data.data.count_emails
					this.missing = response.data.data.missing
					this.countMissing = response.data.data.count_missing
					this.pecs = response.data.data.pecs
					this.countPecs = response.data.data.count_pecs

					this.filtered = true

				}, response => {
					// error callback
				});
			},


		},
	}
</script>